<template>
    <nav class="navbar main-nav is-light is-transparent is-fixed-top">
        <div class="container">
            <div class="navbar-brand">
                <router-link class="navbar-item" :to="{name: 'Home'}" exact>
                    <img src="/img/logo.png" alt="Logo" style="height: 2em">
                </router-link>
                <notification-nav class="nav-child"
                                  @incoming-call="handleIncomingCall"
                                  @invalid-phone-number="$emit('invalid-phone-number')"
                                  @worker-update="handleWorkerUpdate"
                />
                <span v-if="isOperador()" class="navbar-item" @click="handleOutcomingCall">
                    <a class="navbar-item" ><i class="fas fa-phone fa-lg"></i></a>
                </span>
                <profile-nav class="nav-child" />
                <span class="navbar-burger burger nav-child" :class="toggle?'is-active': ''" @click="$emit('openMenu')">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </div>
            <div class="navbar-menu">
                <div class="navbar-end">
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "MainNav",
        props: {
            toggle: {
                default: false
            }
        },
        methods: {
            handleIncomingCall(e) {
                this.$emit('incoming-call', e);
            },
            handleOutcomingCall(e) {
                this.$store.commit('showOutcoming', true);
            },
            isOperador() {
                return this.$auth.check(['ivr_worker']);
            },
            handleWorkerUpdate(e){
                this.$emit('worker-update', e);
            }
        }
    }
</script>

<style scoped>

</style>
